module.exports = __webpack_public_path__ + "bb850459efb14c3daf107684c974ada5.svg";